// extracted by mini-css-extract-plugin
module.exports = {"nextProject":"NextProject_nextProject__anoJf","arrowButton":"NextProject_arrowButton__9wRah"};